module.exports = __webpack_public_path__ + "img/illustration-step-1-02.deb947e9.svg";